import { SelectOption } from '@/components/form-builder/form-builder.types';
import { Ao, AoDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface AoStateProps {
  response?: Ao;
  createDto: AoDto;
  updateDto: Partial<AoDto>;
  ppmSelected: SelectOption;
  milestoneSelected: SelectOption;
}

export const aoInitialState: AoStateProps = {
  response: undefined,
  createDto: {
    ppmId: undefined,
    ppmVer: undefined,
    realisationId: undefined,
    realisationVer: undefined,
    reference: '',
    nom: '',
    description: '',
  },
  updateDto: {
    nom: '',
    description: '',
  },
  ppmSelected: {
    name: '',
    code: '',
  },
  milestoneSelected: {
    name: '',
    code: '',
  },
};

export const aoStateStore = createStore(
  { name: 'ao-state' },
  withProps<AoStateProps>({
    ...aoInitialState,
  })
);
